import React, { useState, useEffect, useContext } from "react";
import UserData from "./UserData";
import TenantData from "./TenantData";
import Confirm from "./Confirm";
import Success from "./Success";
import CardWrap from "../Common/CardWrap";
import StoreData from "./StoreData";
import PosData from "./PosData";
import CertificateData from "./CertificateData";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useBeforeunload } from "react-beforeunload";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { useHistory } from "react-router-dom";
import { Prompt } from "react-router";

const Form = () => {
  const { t: translator } = useTranslation();
  const history = useHistory();

  const { updateLocTab, updateLocName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  useEffect(() => {
    if (![master, admin, support].includes(Number(roleId)))
      history.push("/error-page/401");
    updateLocName("onboarding");
    updateLocTab(0);
  }, []);

  useBeforeunload(() => "You'll lose your data!");

  const [state, setState] = useState({
    step: 1,
    subscriptionValidFrom: "",
    subscriptionValidTo: "",
    validFrom: "",
    validTo: "",
  });

  const [createTenantData, setCreateTenantData] = useState({
    code: "",
    name: "",
    owner: "",
    taxNumber: "",
    street: "",
    streetNumber: "",
    streetNumberExtension: "",
    city: "",
    countryId: 1,
    postalNumber: "",
    iban: "",
    fiscalObligation: true,
    taxObligation: 1,
    taxNote: "",
    image: null,
    accountingActive: false,
  });

  const [createUserData, setCreateUserData] = useState({
    userId: null,
    loginName: "",
    realName: "",
    printName: "",
    personalIdentificationNumber: "",
    phone: "",
    email: "",
    pin: "",
    roleId: 4,
    posPriceEdit: true,
    posDiscountEdit: true,
    rfidTag: "",
  });

  const [createStoreData, setCreateStoreData] = useState({
    description: "",
    tag: "",
    type: "",
    footerNote: "",
    street: "",
    streetNumber: "",
    streetNumberExtension: "",
    city: "",
    postalNumber: "",
    countryId: 1,
  });

  const [createPosData, setCreatePosData] = useState({
    tag: "",
    deposit: "",
    description: "",
    documentNumber: 1,
    posSerialNumber: "",
    subscriptionValidFrom: "",
    //subscriptionValidTo: "",
    msisdn: "",
    tid: "",
    inventoryNumber: "",
  });

  const [uploadCertificateData, setUploadCertificateData] = useState({
    name: "",
    fileContent: null,
    validFrom: null,
    validTo: null,
  });

  const [logoPreview, setLogoPreview] = useState("");
  const [removeLogo, setRemoveLogo] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const nextStep = () => {
    const { step } = state;
    setState({ ...state, step: step + 1 });
  };

  const prevStep = () => {
    const { step } = state;
    setState({ ...state, step: step - 1 });
  };

  const inputChange = (input) => (e) => {
    setState({ ...state, [input]: e.target.value });
  };

  const handleInputChange = (attrName, value, attrName2, value2) => {
    setState({ ...state, [attrName]: value, [attrName2]: value2 });
  };

  const { step } = state;

  switch (step) {
    case 1:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-Tenant")}
            progress="20"
          >
            <TenantData
              nextStep={nextStep}
              createTenantData={createTenantData}
              setCreateTenantData={setCreateTenantData}
              logoPreview={logoPreview}
              setLogoPreview={setLogoPreview}
              removeLogo={removeLogo}
              setRemoveLogo={setRemoveLogo}
              values={state}
            />
          </CardWrap>
        </>
      );
    case 2:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-User")}
            progress="40"
          >
            <UserData
              prevStep={prevStep}
              nextStep={nextStep}
              createUserData={createUserData}
              setCreateUserData={setCreateUserData}
              values={state}
            />
          </CardWrap>
        </>
      );
    case 3:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-Store")}
            progress="60"
          >
            <StoreData
              nextStep={nextStep}
              prevStep={prevStep}
              createStoreData={createStoreData}
              setCreateStoreData={setCreateStoreData}
              values={state}
            />
          </CardWrap>
        </>
      );
    case 4:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-POS")}
            progress="80"
          >
            <PosData
              nextStep={nextStep}
              prevStep={prevStep}
              createPosData={createPosData}
              setCreatePosData={setCreatePosData}
              inputChange={inputChange}
              handleInputChange={handleInputChange}
              values={state}
            />
          </CardWrap>
        </>
      );
    case 5:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-CertificateEntry")}
            progress="100"
          >
            <CertificateData
              nextStep={nextStep}
              prevStep={prevStep}
              uploadCertificateData={uploadCertificateData}
              setUploadCertificateData={setUploadCertificateData}
              showPreview={showPreview}
              setShowPreview={setShowPreview}
              handleInputChange={handleInputChange}
              values={state}
            />
          </CardWrap>
        </>
      );
    case 6:
      return (
        <>
          <Prompt
            when={true}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <CardWrap
            step={step}
            subtitle={translator("Onboarding-Subtitle-DataVerification")}
          >
            <Confirm
              nextStep={nextStep}
              prevStep={prevStep}
              values={state}
              createTenantData={createTenantData}
              createUserData={createUserData}
              createStoreData={createStoreData}
              createPosData={createPosData}
              uploadCertificateData={uploadCertificateData}
            />
          </CardWrap>
        </>
      );
    case 7:
      return (
        <CardWrap
          step={step}
          subtitle={translator("Onboarding-Subtitle-Success")}
        >
          <Success />
        </CardWrap>
      );
  }
};

export default Form;
